import axios from "../axiosInstance"
import { EmailAttachment } from "@/types"

export const getMicrosoftAuthUrl = async (returnPath?: string) => {
  try {
    const res = await axios.get("/emails/auth/microsoft", {
      params: returnPath ? { returnPath } : undefined,
    })
    const { data } = res
    if (!data.success) {
      throw new Error("Failed to get Microsoft auth URL")
    }
    return data
  } catch (error) {
    console.error("Error getting Microsoft auth URL:", error)
    throw error
  }
}

export const getMicrosoftConnectionStatus = async () => {
  try {
    const res = await axios.get("/emails/auth/microsoft/status")
    const { data } = res
    if (!data.success) {
      throw new Error("Failed to get Microsoft connection status")
    }
    return data
  } catch (error) {
    console.error("Error getting Microsoft connection status:", error)
    throw error
  }
}

export const disconnectMicrosoft = async () => {
  try {
    const res = await axios.post("/emails/auth/microsoft/disconnect")
    const { data } = res
    if (!data.success) {
      throw new Error("Failed to disconnect Microsoft")
    }
    return data
  } catch (error) {
    console.error("Error disconnecting Microsoft:", error)
    throw error
  }
}

export const triggerNdaListener = async (dryRun: boolean = false) => {
  const res = await axios.post("/nda-listener/process", { dryRun })
  return res.data
}

export const getEmailsForDeal = async (dealId: number) => {
  try {
    const res = await axios.get(`/emails/deal/${dealId}`)
    const { data } = res
    if (!data.success) {
      throw new Error("Failed to fetch emails for deal")
    }
    return data
  } catch (error) {
    console.error("Error fetching emails for deal:", error)
    throw error
  }
}

export const getDealEmailAttachments = async (messageId: string): Promise<EmailAttachment[]> => {
  const res = await axios.get("/emails/attachments", { params: { messageId } })
  return res.data.attachments
}
